import React, { Component } from 'react';
import {
  Alert, Spinner, Table,
} from 'react-bootstrap';
import { PageStatus } from 'enums';
import {Show} from "../../Layout";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import moment from "moment/moment";
import {exportToExcel} from "../../Utils/ExportToExcel";
import {AuthAPI} from "../../API";
import ShowDataAccording2PageSize from '../ShowEntries/ShowEntries';
import PaginationNumbering from '../ShowEntries/Pagination';
import { formatSmartDate } from "../../Utils/DateFormatter";
import { toast } from 'react-toastify';



const MODAL_TYPES = {
  NONE: 'NONE',
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  DETAILS: 'DETAILS',
};

type State = {
  status: PageStatus,
  error: string | null,
  formType: string,
  data: any[],
  id?: string | null,
  filteredIpData: any[],
  ipFilters: {
    firstName: '',
    email: '',
    phoneNumber: ''
  },
  pageSize: any,
  currentPageNumber: any,
  totalResponseData: any,
  totalResponsePages: any,
  loading: any,
};

export class InactivePanelists extends Component<any, State> {
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      error: null,
      formType: MODAL_TYPES.NONE,
      data: [],
      id: null,
      filteredIpData: [],
      ipFilters: {
        firstName: '',
        email: '',
        phoneNumber: ''
      },
      pageSize: 10,
      currentPageNumber: 1,
      totalResponseData: '',
      totalResponsePages: '',
      loading: false,
    };
    this.fetchList = this.fetchList.bind(this);
  }

  componentDidMount() {
    this.fetchList()
  }

  fetchList(): Promise<void> {
    const { pageSize, currentPageNumber, ipFilters } = this.state;
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => AuthAPI.allInactiveUsers(pageSize, currentPageNumber, ipFilters))
      .then((users) => {
        let ipRespoData: any = users;
        this.setState({ data: ipRespoData.data, filteredIpData: ipRespoData.data, totalResponseData: ipRespoData.totalCount, totalResponsePages: ipRespoData.totalPage, status: PageStatus.Loaded });
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  handleIpFilterChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      (prevState) => ({
        ipFilters: {
          ...prevState.ipFilters,
          [name]: value,
        },
      }),
    );
  };

  applyIpFilters = () => {
    if (this.state.currentPageNumber == 1) { this.fetchList(); return; }
    this.setState({ currentPageNumber: 1 })
  };

  clearIpFilter = async () => {
    await new Promise((resolve: any) =>
     this.setState({
      ipFilters: {
        firstName: '',
        email: '',
        phoneNumber: ''
      },
      pageSize: 10,
      currentPageNumber: 1,
      totalResponseData: '',
      totalResponsePages: ''
    }, resolve));
    this.fetchList();
  }

  async handleIpExport() {
    const { currentPageNumber, ipFilters } = this.state;
    this.setState({ loading: true });
    try {
      await AuthAPI.allInactiveUsers('All', currentPageNumber, ipFilters);
      toast.success('Export started! You will receive an email shortly.');
    } catch (error) {
      console.error("Error exporting data:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handlePageSizeChange = (newIpValue: any) => { this.setState({ pageSize: newIpValue, currentPageNumber: 1 }); };
  handlePageNumberChange = (newIpValue: any) => { this.setState({ currentPageNumber: newIpValue }); };

  componentDidUpdate(prevProps: {}, prevState: State) {
    if (prevState.pageSize !== this.state.pageSize || prevState.currentPageNumber !== this.state.currentPageNumber) { this.fetchList(); }
  };

  render() {
    const { ipFilters, pageSize, currentPageNumber, totalResponseData, totalResponsePages } = this.state;
    return (
      <>
        <GridContainer>
          <div className='w-100 mb-3'>
            <CardHeader color="primary">
              <div className="d-flex align-items-center justify-content-between">
                <h4>Inactive Panelists</h4>
              </div>
            </CardHeader>
          </div>
        </GridContainer>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <div className='mb-3'>Filter</div>
          <form>
            <div className="row">
              <div className="col">
                <label htmlFor='email'>Email</label>
                <input type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="email"
                  value={ipFilters.email}
                  onChange={this.handleIpFilterChange}
                />
              </div>
              <div className="col">
                <label htmlFor='phoneNumber'>Phone Number</label>
                <input type="text"
                  className="form-control"
                  placeholder="Enter..."
                  name="phoneNumber"
                  value={ipFilters.phoneNumber}
                  onChange={this.handleIpFilterChange}
                />
              </div>
            </div>
          </form>

          <div className="jumbotron bg-white p-1 mt-2 shadow-sm">
            <button type="button" className="btn btn-success" onClick={() => this.applyIpFilters()}>Filter Panelists</button>
            <button type="button" className="btn btn-info ml-1" onClick={() => this.handleIpExport()}>Export</button>
            <button type="button" className="btn btn-danger ml-1" onClick={() => this.clearIpFilter()}>Clear Filter</button>
          </div>


        </div>

        <div className="jumbotron bg-white p-3 border shadow-sm">
          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded}>

            <Show when={!this.state.filteredIpData.length}>
              <Alert variant="info" show={!this.state.filteredIpData.length}>
                No data is available
              </Alert>
            </Show>

            <Show when={!!this.state.filteredIpData.length}>
              <div className='mb-2'>
                <ShowDataAccording2PageSize
                  currentPageSize={pageSize}
                  currentPage={currentPageNumber}
                  sendPageSize={this.handlePageSizeChange}
                  showTotalData={totalResponseData}
                  sendLastPage={totalResponsePages}
                />
              </div>
              <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                {this.state.loading && (
                  <img style={{ height: "415px", }}
                    src="../loadernew.gif"
                    alt="Loading..."
                  />
                )}
              </div>
              <Table responsive size="sm" bordered>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>User Id</th>
                    <th>Email</th>
                    <th>Phone Number</th>
                    <th>CreatedAt</th>
                  </tr>
                </thead>

                <tbody>
                  {
                    this.state.filteredIpData.map((ipInfo, index) => (
                      <tr key={ipInfo.id}>
                        <td>{((pageSize) * (currentPageNumber - 1)) + (index + 1)}</td>
                        <td>{ipInfo.id}</td>
                        <td>
                          <button
                            className="text-primary bg-transparent"
                            onKeyPress={() => null}
                            onClick={() => {
                              this.setState({
                                formType: MODAL_TYPES.NONE,
                                id: ipInfo.id,
                              });
                            }}
                            dangerouslySetInnerHTML={{
                              __html: ipInfo.email || '-',
                            }}
                          ></button>
                        </td>
                        <td>{ipInfo.phoneNumber}</td>
                        <td>{formatSmartDate(ipInfo.createdAt)}</td>
                      </tr>
                    ))
                  }
                </tbody>

              </Table>
              <div>
                <PaginationNumbering
                  currentPage={currentPageNumber}
                  returnPagenumber={this.handlePageNumberChange}
                  showTotalData={totalResponseData}
                  sendLastPage={totalResponsePages}
                />
              </div>
            </Show>
          </Show>
        </div>
      </>
    );
  }
}
